import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { ReactComponent as DragIcon } from 'assets/DragIcon.svg'
import { ReactComponent as DeleteCard } from 'assets/cross_close_logo.svg'
import React from 'react'

import { Box } from '@mui/material'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'
import { getWidgetDimensions } from '../../../constants/constants'

import { deleteWidgetFromRow } from 'store/dashboardSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { WidgetContainer } from '../styles'
import type { SortableWidgetProps } from '../types'
import { renderWidgetContent } from '../utils/renderWidgetContent'

export const SortableWidget: React.FC<SortableWidgetProps> = ({
	widget,
	isDragging,
	customCellSize,
	rowId,
}) => {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({
			id: widget.id,
			data: {
				type: 'widget',
				widget,
				rowId,
			},
			transition: {
				duration: 320,
				easing: 'cubic-bezier(0.2, 0, 0, 1)',
			},
		})
	const dispatch = useAppDispatch()
	const { isEditMode } = useAppSelector(state => state.dashboardSlice)
	const style = {
		transform: CSS.Translate.toString(transform),
		willChange: 'transform',
		width: '100%',
		transition,
	}

	return (
		<WidgetContainer
			ref={setNodeRef}
			style={style}
			w={getWidgetDimensions(widget.size).w}
			h={getWidgetDimensions(widget.size).h}
			isDragging={isDragging}
			customCellSize={customCellSize}
			{...attributes}
		>
			{isEditMode && (
				<>
					<Box position={'absolute'} top={0} left={'50%'} {...listeners}>
						<DragIcon style={{ cursor: 'grabbing' }} />
					</Box>
					<Box
						position={'absolute'}
						top={24}
						right={24}
						onClick={() => {
							if (rowId) {
								dispatch(
									deleteWidgetFromRow({
										rowId,
										widgetType: widget.type,
									}),
								)
							}
						}}
					>
						<DeleteCard width={16} height={16} cursor='pointer' />
					</Box>
				</>
			)}

			{widget.title && (
				<TypographyPrimary14Bold>{widget.title}</TypographyPrimary14Bold>
			)}

			{renderWidgetContent(widget)}
		</WidgetContainer>
	)
}
